module.exports = __webpack_public_path__ + "static/media/wald.d6de1844.jpg";